import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useWishlist } from "../context/WishlistContext";

export const WishlistButton = ({ productId, variant = "icon", className = "" }) => {
  const { user } = useAuth();
  const { isSaved, toggleSaved } = useWishlist();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const saved = isSaved(productId);

  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      navigate("/login");
      return;
    }
    setBusy(true);
    await toggleSaved(productId);
    setBusy(false);
  };

  if (variant === "button") {
    return (
      <button
        type="button"
        onClick={handleClick}
        disabled={busy}
        className={`inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg border-2 font-semibold transition ${
          saved
            ? "border-rose-500 bg-rose-50 text-rose-600 hover:bg-rose-100"
            : "border-gray-300 text-gray-700 hover:border-rose-400 hover:text-rose-500"
        } ${className}`}
        data-testid={`wishlist-toggle-${productId}`}
        aria-label={saved ? "Remove from wishlist" : "Save to wishlist"}
      >
        <Heart className={`w-4 h-4 ${saved ? "fill-current" : ""}`} />
        {saved ? "Saved" : "Save"}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={busy}
      className={`absolute top-2 right-2 z-10 w-9 h-9 rounded-full bg-white/90 backdrop-blur shadow flex items-center justify-center transition hover:scale-110 ${
        saved ? "text-rose-500" : "text-gray-400 hover:text-rose-500"
      } ${className}`}
      data-testid={`wishlist-toggle-${productId}`}
      aria-label={saved ? "Remove from wishlist" : "Save to wishlist"}
    >
      <Heart className={`w-5 h-5 ${saved ? "fill-current" : ""}`} />
    </button>
  );
};
